module.exports = __webpack_public_path__ + "img/signedlegal.9666f8ba.png";